import React from 'react'
import Hero from './home/Hero'
import Vision from './home/Vision'
import Aboutus from './home/Aboutus'
import {Helmet} from 'react-helmet'

function Home() {
    return (
        <>
            <Helmet>
                <title>Avalokana Society</title>
                <meta meta="description" content="Avalokana is a historical and philosophical society whose main aim is to spread a word about History, Culture and Philosophy of the Indian Subcontinent"></meta>
            </Helmet>
            <Hero/>
            <Aboutus/>
            <Vision/>
        </>
    )
}

export default Home
